import Vue from 'vue'
import App from './App.vue'
import VueCarousel from 'vue-carousel';
//import vuetify from './plugins/vuetify'
import router from './router';
import VueCookie from 'vue-cookie'
import axios from 'axios';

//import $ from 'jquery'
//Vue.prototype.$ = $

Vue.config.productionTip = false
Vue.use(VueCookie)
Vue.use(VueCarousel);


//axios.defaults.baseURL = 'http://m1.snadx.com:10001' // 테스트
//axios.defaults.baseURL = 'http://m1.snadx.com:10011' // 상용 - IP
//axios.defaults.baseURL = 'https://m.shockping.com/' // 상용 - 도메인
//axios.defaults.withCredentials = true;

const eventBus = {}
eventBus.install = function (Vue) {
    Vue.prototype.$eventBus = new Vue()
}
Vue.use(eventBus)


axios.interceptors.response.use(
    (response) => {
        return response;},
    function (error) {

        console.log(error.response.data);

        if(error.response.status === 401){
            const sessionType = error.response.data.sessionType;
            if(sessionType == 0){ // 로그인 필요

                app.$children[0].loginDialog = true;
                // console.log(234, app.$children[0].loginDialog);

            }else if(sessionType == 2){ // 샵개설 필요
                alert('마이샵 개설이 필요합니다.\n마이샵 개설 페이지로 이동합니다.');
                window.open('https://myshop.shockping.com/plan/start_mall?url=https://home.shockping.com/', '_self');
            }else if(sessionType == 8){ // 마이샵 세션 만료
                alert('로그인 세션이 만료되었습니다.\n로그인 페이지로 이동합니다.');
                window.open('https://my.shockping.com/user/login?url=' + window.location.href, '_self');
            }else if(sessionType == 9){
                alert('로그인 세션 체크 오류');
                return;
            }
        }


        return Promise.reject(error);
    }
);

Vue.prototype.$http=axios

import store from './store';
const app = new Vue({
    //vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
